var _class, _descriptor, _CategoryDropMoreCollection;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import { inject as service } from "@ember/service";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { ALL_CATEGORIES_ID, NO_CATEGORIES_ID } from "select-kit/components/category-drop";
let CategoryDropMoreCollection = (_class = (_CategoryDropMoreCollection = class CategoryDropMoreCollection extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _defineProperty(this, "tagName", "");
  }
  get moreCount() {
    if (!this.args.selectKit.totalCount) {
      return 0;
    }
    const currentCount1 = this.args.collection.content.filter(category1 => category1.id !== NO_CATEGORIES_ID && category1.id !== ALL_CATEGORIES_ID).length;
    return this.args.selectKit.totalCount - currentCount1;
  }
}, template(`
    {{#if this.moreCount}}
      <div class="category-drop-footer">
        <span>
          {{i18n "categories.plus_more_count" (hash count=this.moreCount)}}
        </span>

        {{#if @selectKit.options.parentCategory}}
          <LinkTo
            @route="discovery.subcategories"
            @model={{@selectKit.options.parentCategory.id}}
          >
            {{i18n "categories.view_all"}}
            {{icon "external-link-alt"}}
          </LinkTo>
        {{else}}
          <LinkTo @route="discovery.categories">
            {{i18n "categories.view_all"}}
            {{icon "external-link-alt"}}
          </LinkTo>
        {{/if}}
      </div>
    {{/if}}
  `, {
  component: _CategoryDropMoreCollection,
  eval() {
    return eval(arguments[0]);
  }
}), _CategoryDropMoreCollection), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { CategoryDropMoreCollection as default };